<!-- UNA tarjeta, como Cobranza: encabezado, cifras, segmentado y el cuerpo de la vista. -->
<div class="info-card cb-card">
  <!-- ── 1ª barra · identidad y acciones ── -->
  <div class="card-header">
    <span class="card-icon"><i class="fa-solid fa-gavel"></i></span>
    <div class="cb-head-text">
      <h3>Comités</h3>
      <p>Las sesiones del comité de aprobaciones, la votación por arrendamiento y sus actas.</p>
    </div>

    <div class="header-tags">
      <!-- Solo para quien vota, y solo cuando le falta algo: un «0 pendientes» entrena a ignorarlo. -->
      <button
        *ngIf="pendingVotesChip"
        pButton
        type="button"
        class="p-button-sm cb-alert"
        [label]="pendingVotesChip + (pendingVotesChip === 1 ? ' voto pendiente' : ' votos pendientes')"
        icon="fa-solid fa-check-to-slot"
        (click)="openPending()"
      ></button>

      <button
        *appIfHasPermission="['committee', 'create']"
        pButton
        type="button"
        label="Nueva sesión"
        icon="fa-solid fa-plus"
        class="p-button-sm"
        (click)="openNewSession()"
      ></button>
    </div>
  </div>

  <!-- Las cuatro cifras. Son DATO, no control, y viven en el cascarón: cambiar de vista no las
       vuelve a pedir. En el detalle de una sesión se esconden: ahí manda la sesión. -->
  <div class="cb-funnel" *ngIf="!isDetail">
    <div class="cf-strip" *ngIf="loadingSummary; else cifras" aria-busy="true" aria-label="Cargando el resumen del comité">
      <div class="cf-tile" *ngFor="let t of [1, 2, 3, 4]">
        <p-skeleton height="0.72rem" width="7.5rem"></p-skeleton>
        <p-skeleton height="1.375rem" width="4rem"></p-skeleton>
        <p-skeleton height="0.75rem" width="100%"></p-skeleton>
      </div>
    </div>

    <ng-template #cifras>
      <div class="cf-strip" *ngIf="summary; else sinResumen">
        <div class="cf-tile" [class.is-act]="isActiveTile('sessions')">
          <div class="cf-lbl">
            Sesiones abiertas
            <app-ayuda-cifra titulo="Qué es una sesión lista para cerrar">
              <p>
                Una sesión de votación en la que <b>todos los convocados ya votaron todos los arrendamientos</b>. Legal la cierra y el
                comité queda decidido.
              </p>
              <p>
                Una sesión con votos parciales también se puede cerrar, pero un arrendamiento con menos de la mitad de los votos frena el
                cierre completo.
              </p>
            </app-ayuda-cifra>
          </div>
          <div class="cf-val">{{ summary.openSessions }}</div>
          <div class="cf-sub">
            <b>{{ summary.readyToClose }}</b> {{ summary.readyToClose === 1 ? 'lista' : 'listas' }} para cerrar
          </div>
        </div>

        <div class="cf-tile" [class.is-act]="isActiveTile('votes')">
          <div class="cf-lbl">Votos que faltan</div>
          <div class="cf-val">{{ summary.pendingVotes }}</div>
          <div class="cf-sub">
            <ng-container *ngIf="canVote; else sinVoto">
              <b>{{ summary.myPendingVotes }}</b> {{ summary.myPendingVotes === 1 ? 'es tuyo' : 'son tuyos' }}
            </ng-container>
            <ng-template #sinVoto>en las sesiones abiertas</ng-template>
          </div>
        </div>

        <div class="cf-tile" [class.is-act]="isActiveTile('bring')">
          <div class="cf-lbl">
            Por llevar a comité
            <app-ayuda-cifra titulo="Qué cuenta como por llevar a comité">
              <p>
                Los arrendamientos <b>Pendientes o Aprobados</b> cuyo comité todavía no decidió y que no están en ninguna sesión abierta.
              </p>
              <p>
                El renglón de abajo cuenta otra cosa: contratos ya <b>Activos</b> sin comité registrado. No frenan nada, pero les falta su
                acta — se regularizan desde la pestaña Activos con una sesión de registro.
              </p>
            </app-ayuda-cifra>
          </div>
          <div class="cf-val">{{ summary.leasesToBring }}</div>
          <div class="cf-sub">
            + <b>{{ summary.activeWithoutCommittee }}</b> {{ summary.activeWithoutCommittee === 1 ? 'activo' : 'activos' }} sin comité por
            regularizar
          </div>
        </div>

        <div class="cf-tile" [class.is-act]="isActiveTile('minutes')">
          <div class="cf-lbl">
            Sin acta
            <app-ayuda-cifra titulo="Qué cuenta como sin acta">
              <p>
                Sesiones <b>ya cerradas</b> a las que nadie les ha subido el acta. El acta se sube una vez en la sesión y queda ligada a
                todos sus arrendamientos.
              </p>
            </app-ayuda-cifra>
          </div>
          <div class="cf-val" [class.is-warn]="summary.closedWithoutMinutes > 0">{{ summary.closedWithoutMinutes }}</div>
          <div class="cf-sub">{{ summary.closedWithoutMinutes === 1 ? 'sesión cerrada' : 'sesiones cerradas' }} sin acta</div>
        </div>
      </div>

      <ng-template #sinResumen>
        <p class="cf-caption cf-caption--error">
          <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
          No se pudo cargar el resumen del comité. Las tablas de abajo siguen disponibles.
        </p>
      </ng-template>
    </ng-template>
  </div>

  <!-- ── 2ª barra · la vista ── -->
  <div class="cb-toolbar">
    <div class="cb-seg" role="tablist" aria-label="Vistas de Comités">
      <button
        *ngFor="let v of visibleViews"
        type="button"
        role="tab"
        class="cb-seg-btn"
        [class.is-on]="view === v.key"
        [attr.aria-selected]="view === v.key"
        (click)="goTo(v)"
      >
        <i [class]="v.icon" aria-hidden="true"></i>{{ v.label }}
      </button>
    </div>

    <!-- El mapa de las pestañas: qué NO vas a encontrar en cada una, y en cuál sí está. -->
    <app-ayuda-cifra class="cb-mapa" titulo="Qué contesta cada pestaña">
      <p>Cada una responde <b>una</b> pregunta:</p>
      <ul>
        <li><b>Sesiones</b> — qué sesiones esperan voto, a quién le falta votar y cuáles ya se pueden cerrar.</li>
        <li>
          <b>Por originar</b> — arrendamientos Pendientes y Aprobados que todavía no han pasado por comité. Desde aquí se abre una
          <b>votación</b>.
        </li>
        <li>
          <b>Activos</b> — contratos vivos. Los que no tienen comité registrado se regularizan con una <b>sesión de registro</b> y su acta
          histórica; el estado del arrendamiento no cambia.
        </li>
        <li><b>Cerrados</b> — contratos liquidados. Solo registro documental.</li>
      </ul>
    </app-ayuda-cifra>

    <!-- El detalle de una sesión no es una pestaña: se entra desde la lista o desde el correo. Cuando
         se está dentro, la salida tiene que ser visible. -->
    <button
      *ngIf="isDetail"
      pButton
      type="button"
      label="Volver a sesiones"
      icon="fa-solid fa-chevron-left"
      class="p-button-sm p-button-text"
      (click)="openPending()"
    ></button>
  </div>

  <!-- ── El contenido de la vista, desde la RUTA ── -->
  <div class="cb-body">
    <router-outlet></router-outlet>
  </div>

  <div class="cb-empty" *ngIf="!visibleViews.length">
    <i class="fa-solid fa-lock" aria-hidden="true"></i>
    <p class="cb-empty-t">No tienes acceso a Comités</p>
    <p class="cb-empty-b">Hace falta el permiso de ver el comité. Pídeselo a un administrador.</p>
  </div>
</div>

<!-- FUERA de `.info-card`: la tarjeta tiene `overflow: hidden` y atraparía el modal (ui-styleguide §3.12). -->
<app-new-session-dialog
  [visible]="showNewSession"
  (visibleChange)="onDialogVisibleChange($event)"
  [preselectedIds]="preselectedIds"
  [origin]="origin"
  (created)="onSessionCreated($event)"
></app-new-session-dialog>

<p-toast position="top-right"></p-toast>
